var render = function render(_c,_vm){return (_vm.props.row[_vm.props.column] === true)?_c('el-tag',{attrs:{"type":"success"}},[_vm._v("✔")]):_c('el-tag',{attrs:{"type":"danger"}},[_vm._v("✘")])
}
var staticRenderFns = []

export { render, staticRenderFns }